import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useDeliveryReceiveDispatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.receiveDispatch>) =>
      API.deliveries.receiveDispatch(...args),
    onSuccess: async () => {
      // invalidate the delivery query
      await queryClient.invalidateQueries([QueryKeys.Delivery]);

      // invalidate the deliveries query
      await queryClient.invalidateQueries([QueryKeys.Deliveries]);
    },
  });
};
